import { CommonModule } from '@angular/common';
import { Component, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ToHtmlPipe } from 'src/app/shared/utilities/to-htmlpipe/to-html.pipe';
import { TalkToSalesButtonComponent } from '../../talktosalesButton/talktosalesButton.component';
import { UrlParamsPipe } from 'src/app/shared/utilities/url-params.pipe';
import { ActivatedRoute } from '@angular/router';
import { PosthogService } from 'src/app/shared/services/posthog.service';

@Component({
  selector: 'app-common-usecase-hero',
  templateUrl: './hero.component.html',
  styleUrls: ['./hero.component.scss'],
  imports: [CommonModule, ToHtmlPipe, TalkToSalesButtonComponent, UrlParamsPipe],
})
export class CommonUsecaseHeroComponent implements OnInit {
  @Input() heroData: any;
  @Input() customClass: any;
  @ViewChild('registerLink') registerLink: any;
  queryParams: any;
  constructor(
    private route: ActivatedRoute,
    private posthog: PosthogService
  ) {
    this.route.queryParams.subscribe(params => {
      this.queryParams = params;
    });
  }
  _heroData: any;
  activePanelIds: string[] = [];
  ngOnInit(): void {
    this._heroData = this.heroData;
  }
  ngOnChanges(): void {
    this._heroData = this.heroData;
  }
  openRegisterLink(event:any, target?:string) {
    event.preventDefault();
    const link = this.registerLink.nativeElement.href;
    const searchParams = location.search !== '' ? location.search.slice(1) : '';
    let linkHasParams = new URLSearchParams(link) as any;
    let url = link;
    if(searchParams !== ''){
      if(linkHasParams.search > 0){
        url = `${link}&${searchParams}`;
      }else{
        url = `${link}?${searchParams}`;
      }
    }
    window.open(url, target || '_blank');
  }

  onHeroCTAClick(): void {
    const action = this._heroData?.button1?.text?.toLowerCase().replace(/\s+/g, '_') || 'get_started';
    this.posthog.captureCTAClick(action, 'hero', {
      ctaText: this._heroData?.button1?.text,
      destinationUrl: this._heroData?.button1?.url
    });
  }
}
